package gr.tech.site.models

data class ArticleEntry(
    val route: String,
    val title: String,
    val routeOverride: String,
    val desc: String,
    val author: String,
    val date: String,
    val updated: String,
    val tags: List<String> = emptyList(),
    val image: String = "",
) {
    private fun String.escapeQuotes() = this.replace("\"", "\\\"")
    fun toEntry() = """ArticleEntry("$route", "${title.escapeQuotes()}", "${routeOverride.escapeQuotes()}", "${desc.escapeQuotes()}", "$author", "$date", "$updated", listOf(${tags.joinToString(", ") { "\"${it.replace("\"", "\\\"")}\"" }}))"""
}
